import React from "react";

import { useIntl } from "react-intl";

import { APP_NAME } from "Constants/documentationUrls";
import { Button } from "ds/Button";
import useDecodedParams from "Hooks/useDecodedParams";
import logo from "Vendor_resources/images/logo-ui.svg";

import * as S from "./SubscribeBanner.styles";

const SubscribeBanner = () => {
  const intl = useIntl();
  const { organizationId } = useDecodedParams<{
    organizationId: string;
  }>();

  return (
    <S.Wrapper>
      <img src={logo} alt={APP_NAME} />
      <S.BodyText size="small" weight="semiBold">
        {intl.formatMessage(
          {
            id: "configure_resources.banner.sentence"
          },
          { app_name: APP_NAME }
        )}
      </S.BodyText>
      <Button
        variant="primary"
        analyticId="organization.billing.subscribe.btn.upgrade"
        to={`/${organizationId}/-/subscribe`}
      >
        {intl.formatMessage({
          id: "organization.billing.subscribe.btn.upgrade",
          defaultMessage: "Upgrade"
        })}
      </Button>
    </S.Wrapper>
  );
};

export default SubscribeBanner;
